<div class="/*row*/" *ngIf="collectionSize > noPerPage">
    <div class="justify-content-center" id="logo">
        
        <ngb-pagination [collectionSize]="collectionSize" [disabled]="disabled" [(page)]="page" [maxSize]="maxSize"
            [rotate]="true" (pageChange)="pageChanged()" [pageSize]="pageSize"> </ngb-pagination>
  
    </div>
</div>